import React from 'react'

import { Icon } from '@fourthwall/components'
import { ExclamationMarkIcon } from '@fourthwall/icons'

import * as S from './Warning.styled'

export const Warning = () => (
  <S.WarningContainer>
    <S.WarningContent>
      <S.WarningIconWrapper>
        <Icon component={ExclamationMarkIcon} height={20} />
      </S.WarningIconWrapper>
      <S.WarningText>
        Never share your API credentials publicly or include them in custom HTML code. Exposing API
        keys in embedded code can lead to unauthorized access and misuse of your account.
      </S.WarningText>
    </S.WarningContent>
  </S.WarningContainer>
)
